@use '@/scss/underscore' as _;

.factorList {
  @include _.flex-column;
  gap: _.unit(3);
}
